import React, {
  Fragment,
  useCallback,
  useEffect,
  useRef,
  useState,
} from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { translate } from '../Services/translation';
import { query, searchFacetChange } from '../Actions/FacetedSearch.action';
import Collapsible from './Collapsible';
import useIsMobile from '../Hooks/useIsMobile';
import InputRange from 'react-input-range';
import 'react-input-range/lib/css/index.css';
import { debounce } from 'lodash-es';

const isPriceFacet = (id) => {
  return id == 'price_range';
};

const FacetedSearchGroup = (props) => {
  const dispatch = useDispatch();
  const { productsWrapper } = useSelector((state) => state.productsView);
  const { group } = props;
  const [isOpen, setIsOpen] = useState(true);
  const [sizeInputValue, setSizeInputValue] = useState('');
  const groupRef = React.createRef();
  const specialFilterIds = [
    'FilterColor',
    'Size',
    'Brand',
    'price_range',
    'width_range',
    'length_range',
  ];
  const [showAllFiltersInList, setShowAllFiltersInList] = useState(false);
  const filtersToShow = 10;
  const isMobile = useIsMobile();
  const [selectedRanges, setSelectedRanges] = useState({ min: 0, max: 1 });
  const { priceDisplayQuantity } = productsWrapper;
  const showingPricesForOne =
    !priceDisplayQuantity || priceDisplayQuantity == 1;

  const toggleShowAllFilters = () => {
    showAllFiltersInList
      ? setShowAllFiltersInList(false)
      : setShowAllFiltersInList(true);
  };
  const label = (
    <div>
      {group.label}
      {group.selectedOptions.length > 0 && !group.asSlider ? (
        <span>({group.selectedOptions.length})</span>
      ) : (
        ''
      )}
    </div>
  );

  const filteredAndSortedOptions = (list) => {
    const filteredList = list
      .filter(
        (item) =>
          sizeInputValue == '' ||
          group.selectedOptions.includes(item.id) ||
          item.label.toLowerCase().includes(sizeInputValue.toLowerCase())
      )
      .sort((a, b) => (a.label > b.label ? 1 : -1));
    filteredList > filtersToShow && setShowAllFiltersInList(true);
    return filteredList;
  };

  useEffect(() => {
    calculateSliderValues();
  }, [group]);

  const calculateSliderValues = () => {
    if (group.options && group.asSlider) {
      if (group.selectedOptions && group.selectedOptions.length > 0) {
        const ids = group.selectedOptions.map((object) => {
          return parseFloat(object);
        });
        let low = Math.min(...ids);
        let high = Math.max(...ids);

        updateSliderValues({ min: low, max: high });
      } else {
        const ids = group.options.map((object) => {
          return parseFloat(object.id);
        });
        let high = Math.max(...ids);
        let low = Math.min(...ids);

        updateSliderValues({ min: low, max: high });
      }
    }
  };

  const updateSliderValues = (value) => {
    setSelectedRanges(value);
  };

  const onSliderChange = (group, value) => {
    var selectedValues = [value.min, value.max];
    dispatch(searchFacetChange(group, selectedValues));
  };

  const getSliderValues = () => {
    if (group.options) {
      const ids = group.options.map((object) => {
        return parseFloat(object.id);
      });
      let high = Math.max(...ids);
      let low = Math.min(...ids);
      let unit = group.unitOfMeasurement;
      return (
        <ul className="filter-list-wrapper" ref={groupRef}>
          <div className="slider-filter">
            <div className="slider-filter__labels">
              <span>{`${selectedRanges.min} ${unit}`}</span>
              <span>{`${selectedRanges.max} ${unit}`}</span>
            </div>
            <InputRange
              maxValue={high}
              minValue={low}
              formatLabel={(value) => `${value} ${unit}`}
              value={selectedRanges}
              onChange={(value) => updateSliderValues(value)}
              onChangeComplete={(newValue) => onSliderChange(group, newValue)}
            />
          </div>
        </ul>
      );
    }
  };

  return (
    <Collapsible
      initiallyOpen={!isMobile ? true : false}
      label={label}
      className={
        'filter-group filter-header' + (isOpen ? ' filter-group--open' : '')
      }
      onStateChange={(open) => setIsOpen(open)}
    >
      {!specialFilterIds.includes(group.id) && (
        <ul className="filter-list-wrapper" ref={groupRef}>
          {group.options &&
            group.options.map((item, idx, array) => (
              <li key={`${item.label}-${item.id}`}>
                <FacetedFilterCheckbox item={item} group={group} />
              </li>
            ))}
        </ul>
      )}
      {group.id == 'FilterColor' && (
        <ul className="filter-list-wrapper" ref={groupRef}>
          {group.options &&
            group.options.map((item, idx, array) => (
              <li key={`${item.label}-${item.id}`}>
                <FacetedFilterCheckbox item={item} group={group} />
              </li>
            ))}
        </ul>
      )}
      {group.id == 'Size' && (
        <>
          <input
            placeholder={translate('global.search')}
            className="size-search"
            type="search"
            onChange={(e) => setSizeInputValue(e.target.value)}
          />
          <ul
            className="filter-list-wrapper filter-list-wrapper--size"
            ref={groupRef}
          >
            {group.options &&
              filteredAndSortedOptions(group.options)
                .slice(
                  0,
                  showAllFiltersInList
                    ? filteredAndSortedOptions(group.options).length
                    : filtersToShow
                )
                .map((item, idx, array) => (
                  <li key={`${item.label}-${item.id}`}>
                    <FacetedSizeCheckbox item={item} group={group} />
                  </li>
                ))}
            {filteredAndSortedOptions(group.options).length > filtersToShow && (
              <div
                className="filter-group__show-more"
                onClick={() => toggleShowAllFilters()}
              >
                {!showAllFiltersInList
                  ? translate('global.show-more')
                  : translate('global.show-less')}
              </div>
            )}
          </ul>
        </>
      )}
      {group.asSlider === true && getSliderValues(group)}
    </Collapsible>
  );
};

const FacetedFilterCheckbox = ({ item, group, index }) => {
  const dispatch = useDispatch();
  const onChange = useCallback(
    (group, item) => dispatch(searchFacetChange(group, item)),
    []
  );
  return (
    <div className="checkbox-wrapper">
      <label
        htmlFor={item.label}
        className="[ checkbox-wrapper--label ] [ text-medium lh-2 color-grey-900 ]"
      >
        {item.label}
      </label>
      <div>
        {!isNaN(item.quantity) && item.quantity != null && (
          <span className="[ checkbox-wrapper--quantity ] [ text-medium color-grey-500 lh-2 ]">
            &nbsp;({item.quantity})
          </span>
        )}
        <input
          type="checkbox"
          id={item.label}
          className="checkbox-wrapper--input checkbox"
          onChange={(event) => onChange(group, item)}
          checked={
            group.selectedOptions != null &&
            group.selectedOptions.includes(item.id)
          }
        />
      </div>
    </div>
  );
};

const FacetedSizeCheckbox = ({ item, group }) => {
  const dispatch = useDispatch();
  const onChange = useCallback(
    (group, item) => dispatch(searchFacetChange(group, item)),
    []
  );
  if (item.quantity <= 0) {
    return null;
  } else {
    return (
      <div className="checkbox-wrapper checkbox-wrapper--size">
        <label
          htmlFor={item.label}
          className="[ checkbox-wrapper--label ] [ text-medium lh-2 color-grey-900 ]"
        >
          {item.label}
        </label>
        <div>
          {!isNaN(item.quantity) && item.quantity != null && (
            <span className="[ checkbox-wrapper--quantity ] [ text-medium color-grey-500 lh-2 ]">
              &nbsp;({item.quantity})
            </span>
          )}
          <input
            type="checkbox"
            id={item.label}
            className="checkbox-wrapper--input checkbox"
            onChange={(event) => onChange(group, item)}
            checked={
              group.selectedOptions != null &&
              group.selectedOptions.includes(item.id)
            }
          />
        </div>
      </div>
    );
  }
};
const FacetedColorCheckbox = ({
  item,
  group,
  searchFacetChange,
  textOptionValue,
}) => {
  const checked =
    group.selectedOptions && group.selectedOptions.includes(item.id);
  const dispatch = useDispatch();
  const onChange = useCallback(
    (group, item) => dispatch(searchFacetChange(group, item)),
    []
  );

  return (
    <div className="color-filter">
      <div className="color-checkbox-wrapper">
        <input
          type="checkbox"
          className="hidden-checkbox checkbox"
          htmlFor={item.label}
          checked={checked}
          onChange={(event) => onChange(group, item)}
        />
        <label
          id={item.label}
          className="color-[ checkbox-wrapper--label ] [ text-medium lh-2 color-grey-900 ]"
        >
          <div></div>
        </label>
      </div>
      {item.label}
    </div>
  );
};
const FacetedSearch = () => {
  const dispatch = useDispatch();
  const { facetFilters, navigationTheme } = useSelector(
    (state) => state.facetedSearch
  );

  useEffect(() => {
    // listen to history events (back, forward) of window
    window.onpopstate =
      window.onpopstate ||
      ((event) => {
        dispatch(query(window.location.search.substr(1) || ''));
      });
  }, []);

  return (
    navigationTheme !== 'category' && (
      <ul className="faceted-search">
        {facetFilters &&
          facetFilters.map((group, groupIndex) => (
            <FacetedSearchGroup
              key={`${group.label}-${groupIndex}`}
              group={group}
            />
          ))}
      </ul>
    )
  );
};

export default FacetedSearch;
